// extracted by mini-css-extract-plugin
module.exports = {"h1":"_1IbjvH8BvScX6WlcbAetZR"};